import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "../../icons/NuevoLogoPiSeun.png";
import "./login.css";
import { useStoreLogin } from "./useStoreLogin";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password as PRPassword } from "primereact/password";

export default function Login() {
  const navigate = useNavigate();
  const Mail = useStoreLogin((state) => state.Mail);
  const PasswordValue = useStoreLogin((state) => state.Password);
  const LoginOk = useStoreLogin((state) => state.LoginOk);
  const Procesando = useStoreLogin((state) => state.BuscandoOperador);

  const handleLogin = (e) => {
    e.preventDefault();
    useStoreLogin.getState().validarOperador();
  };


  useEffect(() => {
    if (LoginOk) {
      useStoreLogin.setState({ LoginOk: false });
      navigate("/home");
    }
  }, [LoginOk, navigate]);




  const [animar, setAnimar] = useState(false);
  useEffect(() => {
    setAnimar(true);
    useStoreLogin.setState({ Password: "" });
  }, []);

  return (
    <div className={`login-container ${animar ? "animar" : ""}`}>
      <section className="login-card" aria-labelledby="login-title">
      <header className="login-header">
        <img src={Logo} alt="PiSeun" className="login-logo" />
        <div><span>Gestión simple</span><h1 id="login-title">Bienvenido a PiSeun</h1><p>Ingresá para administrar tu negocio.</p></div>
      </header>
      <BlockUI blocked={Procesando} className="login-block"
        template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >
        <form className="login-forms" onSubmit={handleLogin}>
          <div className="InputLabel">
            <FloatLabel>
              <InputText id="usuario" value={Mail} onChange={(e) => useStoreLogin.setState({ Mail: e.target.value })} />
              <label htmlFor="usuario" className="label-float">Email</label>
            </FloatLabel>
          </div>
          <div className="InputLabel">
            <FloatLabel>
               <PRPassword
                inputId="contraseña"
                value={PasswordValue}
                onChange={(e) => useStoreLogin.setState({ Password: e.target.value })}
                toggleMask
                feedback={false}
                autoComplete="current-password"
                className="pw-field"
              />
              <label htmlFor="contraseña" className="label-float">Contraseña</label>
            </FloatLabel>
          </div>

          <button type="submit" className="btn-login">Continuar <i className="pi pi-arrow-right" aria-hidden="true" /></button>
        </form>
      </BlockUI>
      <p className="register-link" >
        ¿No tenes cuenta? <Link to="/registro">REGISTRATE</Link>
      </p>
      <Link
        to="/tutorial"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-tutorial"
        aria-label="Abrir el instructivo de primeros pasos en una pestaña nueva"
      >
        <i className="pi pi-book" aria-hidden="true" /> Instructivo
      </Link>
      </section>
    </div>
  );
};
